import { createFileRoute, Outlet } from '@tanstack/react-router';

import { WizardNavBar } from './wizard-nav-bar.js';

export const Route = createFileRoute('/_authorization-gate/wizard')({
	component: WizardLayout,
});

function WizardLayout() {
	return (
		<>
			<WizardNavBar />
			<Outlet />
		</>
	);
}
